import { useQuery } from '@tanstack/react-query';

import { dictionaryTypes } from '../types';

import { dictionaryApiTypes } from './types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getTaskTypes = (
  viewMode: dictionaryTypes.ViewMode
): Promise<dictionaryApiTypes.ListTaskTypesResponse> => {
  return axios.get('/task-types', { params: { viewMode } });
};

type QueryFnType = typeof getTaskTypes;

type UseGetTaskTypesOptions = {
  viewMode: dictionaryTypes.ViewMode;
  config?: QueryConfig<QueryFnType>;
};

export const useGetTaskTypes = ({ viewMode, config = {} }: UseGetTaskTypesOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    // Opt out of the global refetchOnMount: false. Archive/restore invalidate
    // both viewMode keys, but only the mounted one is refetched — the other is
    // just marked stale and would be served from cache on the next mount.
    refetchOnMount: true,
    ...config,
    queryKey: ['task-types', viewMode],
    queryFn: () => getTaskTypes(viewMode),
  });
};
